<template>
    <div class="page page--center">
        <Header logo-size="xl" />
        <main class="page__main">
            <div class="content">
                <div class="content__body">
                    <Activation1Form />
                </div>
            </div>
        </main>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Activation1Form from '@/components/Activation1Form.vue'

export default {
    name: 'Activation1',
    components: {
        Header,
        Footer,
        Activation1Form,
    },
}
</script>
